import React from "react";
import { useState } from "react";
import {Row,Col,Card} from 'react-bootstrap'
import {Filter} from '../../Common'
import styles from './reportDownload.module.css'
import { createUserReportDownload , getUserReportDownload} from "../../api";


const ReportDownload = () => {
    const [partner,setPartner] = useState('')
    const [startDate,setStartDate] = useState('')
    const [endDate,setEndDate] = useState('')
    const[showMessage, setShowMessage] = useState(false)
    const[userReports, setUserReports] = useState([]);
    const[isUserReportAvailable, setIsUserReportsAvailable] = useState('');
    const partnerList = ["HDFC", "HDFC stockal", "STOCKAL", "ZINC"]


    // const createUserReport = () => {
    //     let start = moment(start_date).format("YYYY-MM-DD")
    //     let end = moment(end_date).format("YYYY-MM-DD")
    //     createUserReportDownload(
    //       partnerId,start,end,userId
    //     )
    //     .then((response) => {
    //       setIsReportGenerating(response.data.data)
    //       setShowMessage(true)
    //       removeMessage()
    //     })
    // }

    // const downloadUserReportApiCall = (e) => {
    //     getUserReportDownload(e).then((response) => {
    //         if(response.data.data.length > 0){
    //             setUserReports(response.data.data);
    //             setLoader(true)
    //         }else{
    //             setIsUserReportsAvailable('No Data Available')
    //             setLoader(true)
    //         }
    //     })
    // }

    const downloadFile = (e) => {
        window.location.href = e
    }


    return(
        <Row>
            <Row>
                <Card className={styles.customCard}>
                    <Card.Body className={styles.customCardBody}>
                        <Filter
                        partner={partner}
                        setPartner={setPartner}
                        startDate={startDate}
                        endDate={endDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        // onSearch={onSubmit}
                        // loading={searchLoading}
                        partnerList={partnerList}
                        />
                    </Card.Body>
                </Card>
            </Row>
            {showMessage ? <div className="generatingMessage">Please wait while the list is getting generated.</div> : ""}
            <Card className={styles.customCard} style={{width:"100%"}}>
                <Card.Body className={`${styles.customCardBody} pt-0`} style={{minHeight:"150px"}}>
                    <Row className="mb-2 mt-1">
                        <Col lg={3}  className={styles.userReportHeading}>
                            Partner Code
                        </Col> 
                        <Col lg={3} className={styles.userReportHeading}>
                            Created At
                        </Col> 
                        <Col lg={2} className={styles.userReportHeading}>
                            Start Date
                        </Col> 
                        <Col lg={2} className={styles.userReportHeading}>
                            End Date
                        </Col> 
                        <Col lg={2} className={styles.userReportHeading}>
                            Download
                        </Col>        
                    </Row>
                    {/* <Loader loaded={loader}> */}
                    {userReports && userReports.length > 0 ? userReports.map((data,index) => {
                        return(
                            <Row className="userReportDataRow pt-2 pb-2 mb-2">
                                <Col lg={3} >
                                    {data.partner}  
                                </Col>
                                <Col lg={3}>
                                    {/* {moment(data.createdAt).format("DD-MM-YYYY")}  */}
                                </Col>
                                <Col lg={2}>
                                    {/* {moment(data.start).format("DD-MM-YYYY")}  */}
                                </Col>
                                <Col lg={2}>
                                    {/* {moment(data.end).format("DD-MM-YYYY")}  */}
                                </Col>
                                <Col lg={2} onClick={() => downloadFile(data.path)}>
                                    <i className="fas fa-download fa-sm text-black" style={{cursor:"pointer"}}></i>
                                </Col>
                            </Row>
                        )
                    }) : isUserReportAvailable}
                    {/* </Loader> */}
                </Card.Body>
            </Card>

        </Row>
    )
}   


export default ReportDownload